
import { mapGetters } from 'vuex'
import DOMPurify from 'isomorphic-dompurify'
import RatingStars from './RatingStars'
import VerifiedIcon from '~/assets/icons/verified.svg'
import TrustpilotIcon from '~/assets/icons/trustpilotlogo.png'

export default {
  name: 'Review',
  components: {
    VerifiedIcon,
    RatingStars,
  },
  props: {
    review: {
      type: Object,
      required: true
    },
    sidebar: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  data () {
    return {
      TrustpilotIcon
    }
  },
  computed: {
    ...mapGetters({
      currentLanguageCode: 'frontend/currentLanguageCode',
    }),
    reviewContent () {
      return DOMPurify.sanitize(this.review.content)
    },
    reviewTitle () {
      return DOMPurify.sanitize(this.review.title)
    },
    date () {
      return (new Date(this.review.createdAt)).toLocaleDateString(this.currentLanguageCode)
    },
    displayName () {
      if (this.review.source !== null) {
        const reviewerName = this.review.consumer.name || this.review.consumer.displayName
        const nameseparator = reviewerName.split(' ')
        let formattedName = nameseparator[0]
        if (nameseparator.length > 1) {
          formattedName += ' ' + nameseparator[1].charAt(0) + '.'
        }
        return formattedName
      } else {
        return this.review.consumer.name || this.review.consumer.displayName
      }
    }
  },
}
